<template>
  <div>
    <div v-if="primaryCta">
      <router-link
        v-if="$mq === 'mob' || $mq === 'ptab'"
        class="btn btn--shape--h48 min-w--217--not-phab min-w--168--phab"
        v-bind:to="{ name: 'NewsSingle', params: { id: newsId }}"
        v-on:click="clickEvent">
        <span>{{ text || "View Post" }}</span>
      </router-link>
      <router-link
        v-else
        class="btn btn--shape--h48 w--100p"
        v-bind:to="{ name: 'NewsSingle', params: { id: newsId }}"
        v-on:click="clickEvent">
        <span>{{ text || "View Post" }}</span>
      </router-link>
    </div>
    <div v-else>
      <mq-layout :mq="['mob', 'ptab']">
        <router-link
          class="fonticon fonticon--plus--circle fs--40"
          v-bind:to="{ name: 'NewsSingle', params: { id: newsId }}"
          v-on:click="clickEvent">
        </router-link>
      </mq-layout>
      <mq-layout :mq="['ltab', 'desk']">
        <router-link
          class="link--action link--arrow"
          v-bind:to="{ name: 'NewsSingle', params: { id: newsId }}"
          v-on:click="clickEvent">
          <span>{{ text || "View Post" }}</span>
        </router-link>
      </mq-layout>
    </div>
  </div>
</template>

<script>
import Btn from "../atoms/Btn";

export default {
  components: {
    Btn
  },
  props: {
    text: String,
    newsId: Number,
    primaryCta: Boolean
  },
  methods: {
    clickEvent(evt) {
      var self = this;

      self.trackEvent([
        "hero-file-download-clicked",
        self.fileName,
        self.$root.$data.user ? self.$root.$data.user.trackName : null,
        0,
        false
      ]);

    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/organisms/NewsHeroButton.vue